/**
 * Transport controls — Play, Pause, Stop. Live only once the Realm is active, same
 * gating as the Hero Knob (ENG-037). Copy is a UI affordance by owner decision,
 * outside receiver dialogue, same treatment as the drop target.
 */
import type { Ctx } from '../core/machine';

export interface TransportHandlers {
  readonly onPlay: () => void;
  readonly onPause: () => void;
  readonly onStop: () => void;
}

export function mountTransportControls(
  parent: HTMLElement,
  handlers: TransportHandlers
): (c: Ctx, live: boolean) => void {
  const wrap = document.createElement('div');
  wrap.className = 'cc-transport';

  const makeButton = (label: string, onClick: () => void): HTMLButtonElement => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-transport-button';
    btn.textContent = label;
    btn.addEventListener('click', onClick);
    return btn;
  };

  const play = makeButton('PLAY', handlers.onPlay);
  const pause = makeButton('PAUSE', handlers.onPause);
  const stop = makeButton('STOP', handlers.onStop);

  wrap.append(play, pause, stop);
  parent.append(wrap);

  return (c: Ctx, live: boolean): void => {
    wrap.hidden = !live;
    play.disabled = !live || c.playing;
    pause.disabled = !live || !c.playing;
    stop.disabled = !live;
  };
}
